import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  // https://css-tricks.com/design-considerations-text-images/
  
  constructor() {

  }
}
